{
  "en": {
    "message": {
      "actions": {
        "delete_message": "Delete Message",
        "move_selected": "Move selected messages",
        "send": "Send"
      },
      "labels": {
        "already_replied": "already has a reply",
        "cannot_delete_message": "This message has already been read by the customer and can therefore not be deleted.",
        "changes_not_saved": "You have unsaved changes. Are you sure you want to continue?\np.s.: You could open a new tab to navigate to other pages simultaneously.",
        "delete_message": "This deletes the message for everyone. Keep in mind that an email notification could already have been sent out, depending on the settings of the recipient.",
        "delete_message_abort": "Message cannot be deleted",
        "move_customer_notification": "The customer will be notified when the message is transferred to another conversation",
        "move_to": "Move message to...",
        "moved_here": "here from conversation",
        "moved_message": "moved this message",
        "moving_message": "Moving message",
        "notSeenYet": "Not seen yet",
        "seen": "Seen by everyone",
        "seen_by": "Seen by {participants}",
        "to": "to",
        "you": "you"
      },
      "validation": {
        "message_required": "Message is required"
      }
    }
  }
}
